// extracted by mini-css-extract-plugin
export default {"icon":"_2d971210"};